export default __webpack_public_path__ + "static/media/boxtype19.b71c5975.JPG";